import { Phone, Instagram, Facebook, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050506] border-t border-white/5 pt-20 pb-10 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="grid md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center">
              <span className="font-display text-lg font-semibold text-white leading-tight">
                Rapid Response
                <span className="block text-[10px] tracking-[0.22em] text-[var(--rr-text-muted)] uppercase">
                  Property Services
                </span>
              </span>
            </div>
            <p className="mt-5 text-[var(--rr-text-muted)] leading-relaxed max-w-md">
              Family-owned property services serving Collegeville and the
              greater Montgomery County area — sealcoating, landscaping,
              lawn care, and snow removal.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/10 text-white/80 hover:text-[var(--rr-accent)] hover:border-[var(--rr-accent)]/40 transition-colors"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="https://www.instagram.com/rapidresponselandscaping.serv"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/10 text-white/80 hover:text-[var(--rr-accent)] hover:border-[var(--rr-accent)]/40 transition-colors"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline">Services</div>
            <ul className="mt-5 space-y-3 text-sm text-[var(--rr-text-muted)]">
              {["Sealcoating", "Landscaping", "Lawn Care", "Snow Removal", "Cleanups", "Mulching"].map((l) => (
                <li key={l}>
                  <a href="#services" className="hover:text-white transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline">Contact</div>
            <ul className="mt-5 space-y-4 text-sm">
              <li>
                <a href="tel:+16109940500" className="flex items-center gap-3 text-white hover:text-[var(--rr-accent)] transition-colors">
                  <Phone className="h-4 w-4" /> 610.994.0500
                </a>
              </li>
              <li className="flex items-start gap-3 text-[var(--rr-text-muted)]">
                <MapPin className="h-4 w-4 mt-0.5" />
                555 2nd Ave, Collegeville, PA 19426
              </li>
              <li className="text-[var(--rr-text-muted)]">
                Mon – Sat · 8:00 AM – 5:00 PM
              </li>
            </ul>
          </div>
        </div>

        {/* Massive brand mark */}
        <div className="border-t border-white/5 pt-12">
          <div
            aria-hidden="true"
            className="font-display font-semibold tracking-tighter text-white/[0.04] text-[15vw] leading-none select-none whitespace-nowrap overflow-hidden"
          >
            RAPID RESPONSE
          </div>
          <div className="mt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-[var(--rr-text-muted)]">
            <p>© {new Date().getFullYear()} Rapid Response Property Services. All rights reserved.</p>
            <p>Licensed & Insured · Serving PA</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
